import { Component, OnInit } from '@angular/core';
import { ChartDataSets, ChartOptions, ChartType } from 'chart.js';
import { Color, Label } from 'ng2-charts';
import { ChartService } from "../shared/chart.service";

@Component({
  selector: 'app-loanchart',
  templateUrl: './loanchart.component.html',
  styleUrls: ['./loanchart.component.css']
})

export class LoanchartComponent implements OnInit {

  public lineChartData: any[] = [];
  public lineChartLabels: Label[] ;
  public lineChartOptions: any;
  public lineChartColors: Color[];

  public lineChartType: ChartType ;
  public lineChartLegend:boolean;
  public lineChartPlugins: [];

  public BranchList: any[] = [];
  public LoanCount: any[] = [];
  public MonthNameList: any[] = [];
  
  constructor(private chartService : ChartService) { }

  ngOnInit() {

   this.GetLoanChart();
  }

  GetLoanChart(){
    this.chartService.FetchLoanChartsList().subscribe(data => {

      data.forEach(branchData => {
        this.BranchList.push(branchData.BranchName)
      });

      data.forEach(branchData => {
        this.LoanCount.push(branchData.LoanCount)
      });
      
      data.forEach(branchData => {
        this.MonthNameList.push(branchData.MonthName)
      });
      
      // data.forEach(branchData => {        
      //   this.lineChartData = [
      //     { data: this.LoanCount , label: branchData.BranchName },
      //   ];
      // });

      this.lineChartData = [
        { data: this.LoanCount , label: this.BranchList[0] },
      ];
    
      this.lineChartLabels = this.MonthNameList;
    
     this.lineChartOptions = {
        responsive: true,
      };
    
      this.lineChartColors = [
        {
          borderColor: 'black',
          backgroundColor: 'rgba(255,255,0,0.28)',
        },
      ];
    
      this.lineChartLegend = true;
      this.lineChartPlugins = [];
      this.lineChartType = 'line';

    })
  }
}
